import React, { useMemo } from 'react';
import { TableCell, TableRow, TextField } from '@material-ui/core';
import { Select } from '@coolremote/shared';
import clsx from 'clsx';
import { t } from 'ttag';

const KeySelectTableRow = ({
  classes,
  value,
  options,
  onChange,
  label,
  selectedOptions,
}) => {
  const handleChange = (event) => {
    onChange(event.target.value);
  };

  const handleSelectChange = (newValue) => {
    onChange(newValue);
  };

  const computedOptions = useMemo(() => {
    if (!options) {
      return null;
    }

    if (Array.isArray(options)) {
      return options;
    }

    return Object.entries(options).map(([key, value]) => ({
      text: value,
      value: key,
    }));
  }, [options]);

  const renderSecondaryField = () => {
    if (!computedOptions) {
      return (
        <TextField
          fullWidth
          variant="outlined"
          placeholder={t`Enter value`}
          value={value ?? ''}
          onChange={handleChange}
          InputProps={{ classes: { root: classes.inputRoot } }}
        />
      );
    }
    return (
      <Select
        value={value ?? ''}
        onChange={handleSelectChange}
        classes={{ trigger: classes.inputRoot }}
        options={mappedOptions}
        menuPortal
        className={classes.width170}
      />
    );
  };

  const reveredSelectedOptions = useMemo(() => {
    const map = {};
    Object.values(selectedOptions || {}).forEach((value) => {
      map[value] = true;
    });
    return map;
  }, [selectedOptions]);

  const mappedOptions = useMemo(() => {
    const list = [{ value: '', label: t`none` }];
    if (computedOptions) {
      computedOptions.forEach(({ value: optValue, text }) => {
        list.push({
          value: optValue,
          label: text,
          disabled: !!reveredSelectedOptions[optValue],
        });
      });
    }
    return list;
  }, [computedOptions, reveredSelectedOptions]);

  return (
    <TableRow key={`row-enum-${label}`}>
      <TableCell classes={{ root: clsx(classes.tableCell) }} align="left" style={{ width: '40%' }}>
        {label}
      </TableCell>
      <TableCell
        classes={{ root: clsx(classes.tableCell) }}
        align="left"
        style={{ width: '60%' }}
      >
        {renderSecondaryField()}
      </TableCell>
    </TableRow>
  );
};

export default KeySelectTableRow;
